import { Events } from "ionic-angular/util/events";
import { WhiskyDB } from "./db";
import { UTFUtil } from "./UtfToStr";

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

export class ImageSync {
  events: Events;
  me: any;

  constructor(events: Events, page: any) {
    this.events = events;
    this.me = page;
    this.setupSaveImageEvent();

    this.events.subscribe("load:next", (i: number, s3, sub) => {
      this.loadImageFromCloud(i, s3, sub);
    });
    this.events.subscribe("save:next", (i: number, s3, sub) => {
      this.saveImageToCloud(i, s3, sub);
    });
    this.events.subscribe("getmore:list", (load, token, s3, sub) => {
      this.getImageTimestampsFromBucket(load, token, s3, sub);
    });
  }

  DEBUG_MAX = 100000;

  cloudBucketSizes = {};
  cloudBucketTimes = {};

  getImageTimestampsFromBucket(
    load: boolean,
    continuationKey: string = null,
    s3 = null,
    sub = null
  ) {
    var ev = this.events;
    var me = this.me;

    if (!WhiskyDB.networkUp) {
      let alert = me.alertCtrl.create({
        title: "Network down",
        message: "Please try again when the network is up",
        buttons: ["Dismiss"]
      });
      alert.present();
      return;
    }

    if (s3 == null) {
      s3 = new AWS.S3({
        params: {
          Bucket: aws_user_files_s3_bucket
        },
        region: aws_user_files_s3_bucket_region
      });

      sub = AWS.config.credentials.identityId;
      me.user.getUser().getUserAttributes((err, data) => {
        if (err) {
          console.log(err);
          let toast = me.toastCtrl.create({
            message: "Error connecting, network down?",
            duration: 3000
          });
          toast.present();
          ev.publish("update:done");
          return;
        }
        let attributes = data;
        console.debug(attributes);
      });
    }

    var params: any;
    params = {
      Bucket: aws_user_files_s3_bucket,
      Prefix: "protected/" + sub + "/images/"
      //MaxKeys: 50,
    };
    if (continuationKey != null) {
      params = {
        Bucket: aws_user_files_s3_bucket,
        Prefix: "protected/" + sub + "/images/",
        ContinuationToken: continuationKey
        //MaxKeys: 50,
      };
    }
    console.log(params);

    s3.listObjectsV2(params, function(err, data) {
      if (err) {
        console.log("Unable to list objects: " + err);
        return;
      }

      //console.log(data);
      data.Contents.forEach(element => {
        let name = element.Key.replace(/^.*images\//, "");

        if (me.cloudBucketSizes == null) me.cloudBucketSizes = {};
        if (me.cloudBucketTimes == null) me.cloudBucketTimes = {};

        me.cloudBucketTimes[name] = element.LastModified;
        me.cloudBucketSizes[name] = element.Size;

        console.log(
          name +
            " " +
            me.cloudBucketTimes[name] +
            " " +
            me.cloudBucketSizes[name]
        );
      });

      //      console.log("done with " + data.KeyCount + " " + data.IsTruncated + " " + data.NextContinuationToken);
      if (data.IsTruncated == true) {
        console.log("More files to check!");
        ev.publish("getmore:list", load, data.NextContinuationToken, s3, sub);
      } else {
        if (load) {
          ev.publish("load:next", 0, s3, sub);
        } else {
          ev.publish("save:next", 0, s3, sub);
        }
      }
    });
  }

  loadAllImagesFromCloud() {
    this.getImageTimestampsFromBucket(true);
  }

  loadImageFromCloud(n: number, s3, sub) {
    let ev = this.events;
    let me = this.me;

    console.log("loadImage: " + n);
    if (n >= WhiskyDB.whisky.length || n == this.DEBUG_MAX) {
      ev.publish("update:done");
      return;
    }
    let w = WhiskyDB.whisky[n];
    this.me.loading_image =
      "Checking " + n + " of " + WhiskyDB.whisky.length + ": " + w.name;

    //console.log(w);
    if (w.image !== "yes") {
      ev.publish("load:next", n + 1, s3, sub);
      return;
    }

    this.me.saving = "yes";
    console.log("Check timestamp on " + w.name + " i=" + n);

    if (s3 === null) {
      s3 = new AWS.S3({
        params: {
          Bucket: aws_user_files_s3_bucket
        },
        region: aws_user_files_s3_bucket_region
      });

      sub = AWS.config.credentials.identityId;
      me.user.getUser().getUserAttributes((err, data) => {
        if (err) {
          console.log(err);
          let toast = me.toastCtrl.create({
            message: "Error connecting, network down?",
            duration: 3000
          });
          toast.present();
          ev.publish("update:done");
          return;
        }

        let attributes = data;
        console.log("attributes: " + attributes);
      });
    }

    let ts = new Date(me.cloudBucketTimes[w.name]).getTime();
    let size = me.cloudBucketSizes[w.name];

    console.log("ts=" + ts + " " + " size=" + size);
    var haveIt = false;

    if (size == 0) {
      haveIt = false;
    } else {
      let wts = WhiskyDB.imageTimestamps[w.name];
      console.log("myTs=" + wts + " size=" + WhiskyDB.imageSizes[w.name]);

      if (ts <= wts || WhiskyDB.imageSizes[w.name] == size) {
        console.log("Already have it " + ts + " <=" + wts);
        haveIt = true;
      } else {
        console.log("Need to get it " + ts + " > " + wts);
        haveIt = false;
      }
    }

    if (haveIt) {
      ev.publish("load:next", n + 1, s3, sub);
    } else {
      console.log("Reqeusting " + w.name + " queue=" + n);

      s3.getObject(
        {
          Bucket: aws_user_files_s3_bucket,
          Key: "protected/" + sub + "/images/" + w.name
        },
        function(err, data) {
          let loading_image =
            n + " of " + WhiskyDB.whisky.length + ": " + w.name;
          ev.publish("update:loading", loading_image);

          if (err) {
            console.log(err);
            let alert = me.alertCtrl.create({
              title: "Error Loading",
              message: err ? err : "Record not found - image for " + w.name,
              buttons: ["Dismiss"]
            });
            alert.present();
          } else {
            console.log(data.Body.length);
            var converted = UTFUtil.Utf8ArrayToStr(data.Body);

            console.log("Bytes read: " + converted.length);
            WhiskyDB.db.saveImage(w, converted, ts, false);
            ev.publish("update:saving", w.name);
          }
          ev.publish("load:next", n + 1, s3, sub);
        }
      );
    }
  }

  setupSaveImageEvent() {
    let ev = this.events;
    let me = this.me;
    // Actual save to S3 is in the event callback
    ev.subscribe(
      "image:loaded_for_save",
      (image: string, name: string, s3, sub: string, n: number) => {
        if (image === null) {
          ev.publish("save:next", n + 1, s3, sub);
          return
        }
        me.saving_image = name;

        if (s3 === null) {
          s3 = new AWS.S3({
            params: {
              Bucket: aws_user_files_s3_bucket
            },
            region: aws_user_files_s3_bucket_region
          });

          sub = AWS.config.credentials.identityId;
          me.user.getUser().getUserAttributes((err, data) => {
            if (err) {
              console.log(err);
              let toast = me.toastCtrl.create({
                message: "Error connecting, network down?",
                duration: 3000
              });
              toast.present();
              ev.publish("update:done");
              return;
            }

            let attributes = data;
            console.log("attributes: " + attributes);
          });
        }
        console.log("Checking if image is already on S3");
        var needToSend = false;
        let ts = me.cloudBucketTimes[name];
        let size = me.cloudBucketSizes[name];
        let timestamp = WhiskyDB.imageTimestamps[name];

        if (
          size == 0 ||
          (ts < timestamp && size != WhiskyDB.imageSizes[name])
        ) {
          console.log(
            "Need to send " +
              ts +
              " < " +
              timestamp +
              " s3size=" +
              size +
              " mysize=" +
              WhiskyDB.imageSizes[name]
          );
          needToSend = true;
        } else {
          console.log(
            "No Need to send " +
              ts +
              " < " +
              timestamp +
              " s3size=" +
              size +
              " mysize=" +
              WhiskyDB.imageSizes[name]
          );
          needToSend = false;
        }

        if (!needToSend) {
          ev.publish("save:next", n + 1, s3, sub);
        } else {
          console.log("sending " + name + " to S3");
          s3
            .upload({
              Key: "protected/" + sub + "/images/" + name,
              Body: image,
              ContentType: "image/x-jpeg"
            })
            .promise()
            .then(
              data => {
                console.log("Image saved " + name + " ts=" + data.LastModified);
                ev.publish("save:next", n + 1, s3, sub);
              },
              err => {
                let alert = me.alertCtrl.create({
                  title: "Error Saving",
                  subTitle: name + " image",
                  message: err ? err : "Record not found",
                  buttons: ["Dismiss"]
                });
                ev.publish("save:next", n + 1, s3, sub);
                alert.present();
              }
            );
        }
      }
    );
  }

  saveImagesToCloud() {
    //    let loading = this.loadingCtrl.create({ content: "Saving" });
    //    loading.present();
    this.me.saving_image = "";
    this.me.loading_image = "";

    this.getImageTimestampsFromBucket(false);
  }

  saveImageToCloud(n, s3, sub) {
    let w = WhiskyDB.whisky[n];
    if (w == null || n == this.DEBUG_MAX) {
      this.me.saving = null;
      let toast = this.me.toastCtrl.create({
        message: "Done saving images",
        duration: 3000
      });
      toast.present();
      return;
    }
    if (w.image === "yes") {
      this.me.loading_image =
        n + " of " + WhiskyDB.whisky.length + ": " + w.name;
      this.me.saving = "yes";
      WhiskyDB.db.loadImage(w, true, s3, sub, n);
      console.log("Reqeusting " + w.name + " n=" + n);
    } else {
      this.events.publish("save:next", n + 1, s3, sub);
    }
  }
}



// WEBPACK FOOTER //
// ./src/data/imageSync.ts